export const handleEntities = (entities) => {
  let object = {
    type: "ENTITY",
    entities: entities,
  };
  return object;
};
// redux action that returns async function
const entity = "entity";
const endPoint = `${process.env.REACT_APP_URL}/${entity}/`;
const userEndPoint = `${process.env.REACT_APP_URL}/user/`;
const token = localStorage.getItem("token");
const user = JSON.parse(localStorage.getItem("user"));
export const loadEntity =
  (userInfo = null,getToken) =>
  async (dispatch) => {
    try {
     
      let userDetails = {
        user: userInfo ? userInfo.id : user?.id,
      };

      const success = await fetch(`${endPoint}`, {
        method: "POST",
        body: JSON.stringify(userDetails),
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${getToken||token}`,
        },
      });
      if (success.status === 401) {
       
        throw new Error("Token Expired");
      }
      const entityresponse = await success.json();
      const item = localStorage.getItem("selectedEntity");
      const selectedEntity = JSON.parse(item);

      if (!selectedEntity) {
        localStorage.setItem(
          "entity",
          JSON.stringify(
            entityresponse.entities.length > 0
              ? entityresponse.entities[0]
              : null
          )
        );
        localStorage.setItem(
          "selectedEntity",
          JSON.stringify(
            entityresponse.entities.length > 0
              ? entityresponse.entities[0]
              : null
          )
        );
      }
      await dispatch(handleEntities(entityresponse.entities));
      return entityresponse;
    } catch (error) {
     
      throw new Error(401);
    }
  };

export const handleDashboardSearchPopup = (value) => async (dispatch) => {
  dispatch({
    type: "DASHBOARD_SEARCH_POPUP",
    payload: value,
  });
};

export const updateTourGuide = (params) => {
  const token = localStorage.getItem("token");
  return (dispatch) => {
    return fetch(`${userEndPoint}tour-guide`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    }).then((res) => {
      if (res.status === 401) {
        throw new Error("Token Expired");
      }
      // res.json().then((result) => {
      //   dispatch({
      //     type: "TOUR_GUIDE",
      //   });
      // });
    });
  };
};
